module.exports = __webpack_public_path__ + "static/images/gift1.8150c4b.png";